import React from 'react'
import Suisse from './Suisse'

function Captions({
  size,
  color,
  forceSize,
  sx,
  children,
  onClick,
  align,
  component,
}) {
  return (
    <Suisse
      size={size}
      type="regular"
      color={color}
      forceSize={forceSize}
      sx={{ letterSpacing: '0.14em', textTransform: 'uppercase', ...sx }}
      onClick={onClick}
      align={align}
      component={component}
    >
      {children}
    </Suisse>
  )
}

export default Captions
